<template>
  <button class="flex w-full py-4" @click="navigate">
    <img alt="image" class="h-6 w-6 mr-2" :src="icon" />
    <p class="flex-1 text-left">
      {{ title }}
    </p>
    <button>
      <img alt="image" class="h-6" src="@/assets/icons/chevronright.svg" />
    </button>
  </button>
</template>
<script>
import { Share } from "@capacitor/share";
import { Toast } from "@capacitor/toast";
export default {
  props: {
    title: String,
    icon: String,
    pathName: String,
  },
  methods: {
    navigate() {
      if (this.pathName == "Loyalty") {
        this.loyalty();
      } else if (this.pathName == "ShareApp") {
        this.shareApp();
      } else {
        this.$router.push({ name: this.pathName });
      }
    },
    loyalty() {
      this.$toast.show("Loyalty: Coming Soon", {
        position: "bottom",
        duration: 2000,
      });
    },

    shareApp() {
      Toast.show({ text: "Loading...", position: "bottom" });
      var phone = this.$store.state.phone1;
      var email = this.$store.state.email;
      var android = this.$store.state.appDetails?.update?.androidLink;
      var ios = this.$store.state.appDetails?.update?.iosLink;

      Share.share({
        title: "BandB App Share",
        text:
          "Hi! Check out the Buns and Batter App. Android(" +
          android +
          "), iOS(" +
          ios +
          "). Knead Anything? Call us (" +
          phone +
          ") or Send us an email (" +
          email +
          ").",
        dialogTitle: "BandB App Share",
      })
        .then(() => {
          this.$toast.show("Thank You for sharing our app", {
            position: "bottom",
            duration: 5000,
          });
        })
        .catch((error) =>
          this.$toast.warning(error, {
            position: "bottom",
            duration: 2000,
          })
        );
    },
  },
};
</script>
